import React, { FC, useEffect } from 'react';
import { IHandleNotification } from 'utils/models';
import { useNotifications } from 'hooks/useNotifications';
import NotificationMessages from 'components/notifications/NotificationMessages';
import { toast } from 'components/Toast';

type Props = {
  setHasUnreadNotifications: (param: boolean) => void;
};

const Notifications: FC<Props> = ({ setHasUnreadNotifications }) => {
  const { notifications, isLoading, hasUnread, markAsRead } = useNotifications(true);

  useEffect(() => {
    setHasUnreadNotifications(hasUnread);
  }, [hasUnread, setHasUnreadNotifications]);

  const handleReadNotification = async ({ is_read, id, link }: IHandleNotification) => {
    try {
      if (!is_read) {
        await markAsRead(id);
      }
      if (link) {
        window.location.href = link;
      }
    } catch (err: any) {
      toast({
        title: 'Error',
        message: err?.message || 'Failed to open notification',
        variant: 'error'
      });
    }
  };

  return (
    <NotificationMessages
      notifications={notifications}
      loading={isLoading}
      handleReadNotification={handleReadNotification}
    />
  );
};

export default Notifications;
